// Returns the size of the array or 0 if the array is null or undefined

export const size = <T>(array: T[] | null | undefined): number => {
  return array?.length || 0;
};

// Returns true if the array is null or empty
export const isArrayEmpty = <T>(array: T[] | null | undefined): boolean => {
  return size(array) === 0;
};

// Returns true if the array is not null and not empty
export const hasData = <T>(array: T[] | null | undefined): boolean => {
  return !isArrayEmpty(array);
};

// returns the first element of and array or null if the array is null or empty
export const first = <T>(array: T[] | null | undefined): T | null => {
  return hasData(array) ? array![0] : null;
};

// isEmptyData is an alias for isArrayEmpty
export const isEmpty = isArrayEmpty;
